
import React from 'react';

const AuraProgressBar = ({ current, target, label }) => {
  const progress = target > 0 ? (current / target) * 100 : 0;
  const clampedProgress = Math.max(0, Math.min(100, progress));

  const getProgressColor = () => {
    if (clampedProgress >= 100) return 'bg-green-500';
    if (clampedProgress > 75) return 'bg-blue-500';
    if (clampedProgress > 50) return 'bg-purple-500';
    return 'bg-gray-500';
  };

  return (
    <div className="w-full bg-gray-700 rounded-full h-2.5 mt-2 relative overflow-hidden">
      <div 
        className={`h-full rounded-full transition-all duration-500 ease-out ${getProgressColor()} shadow-lg`}
        style={{ width: `${clampedProgress}%` }}
      >
        {/* Aura effect inside the bar */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-pulse-slow opacity-50"></div>
      </div>
      {label && (
        <p className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-xs font-bold text-white text-shadow-sm">
          {label}
        </p>
      )}
    </div>
  );
};

export default AuraProgressBar;
